import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause--white",
  "use": "icon-pause--white-usage",
  "viewBox": "0 0 59 59",
  "content": "<symbol viewBox=\"0 0 59 59\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause--white\"><g transform=\"translate(1 1)\"><circle cx=\"28.5\" cy=\"28.5\" r=\"28.5\" style=\"fill:none;stroke:#fff;stroke-width:2px\" /><path fill=\"#fff\" d=\"M19 16.5h3v23h-3zm16 0h3v23h-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol